import React from 'react';
import PropTypes from 'prop-types';

function Card({ title, children }) {
  return (
    <div className="card">
      <div className="card-header">
        <h6>{title}</h6>
      </div>
      <div className="card-body">
        {children}
      </div>
    </div>
  );
}

Card.defaultProps = {
  children: [],
};
Card.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.array,
};

export default Card;
